import { useMutation } from "@tanstack/react-query";
import { saveAs } from "@";
import { generateVerificationStagesPdf } from "../requests/generate-pdf.ts";
import type { GenerateVerificationStagesPdfRequest } from "../../types.ts";

export const useDownloadPdfMutation = () => {
  return useMutation({
    mutationFn: async (data: GenerateVerificationStagesPdfRequest) => {
      const response =
        await generateVerificationStagesPdf(data);
      return response.data;
    },
    onSuccess: (data) => {
      const blob = new Blob([data]);
      saveAs(blob, "verification-stages.pdf");
    },
  });
};
